import Button from "antd/es/button";
import React from "react";
import CheckOutlined from "@ant-design/icons/lib/icons/CheckOutlined";
import {inject, observer} from "mobx-react";

const getProductPrice = (productRatePlan) =>
  Number.parseFloat(productRatePlan.productRatePlanCharges.reduce(
    (acc, currentCharge) => acc+currentCharge.pricing[0].price,
    0
  ))

const getDiscountedProductPrice = (productRatePlan, discountAmount) => {
  const originalPrice = getProductPrice(productRatePlan);

  if (originalPrice) {

    if (discountAmount.isPercentage) {
      return originalPrice - (originalPrice / 100 * discountAmount.amount);
    } else {
      return originalPrice - discountAmount.amount;
    }
  }
  return undefined;
}

const ServiceListItem = ({title, subtitle, showCheckmark, price, discountedPrice}) => (
  <div className="ServiceListItem">
    <div className="ListItemContainer">
      {showCheckmark && <div className="ListIcon"><CheckOutlined width={16} height={16}/></div>}
      <div>
        <div>{title}</div>
        {subtitle && <div className="ListItemSubtitle">{subtitle}</div>}
      </div>
    </div>
    <div className={'PriceContainer'}>
      {discountedPrice !== undefined && <div className='DiscountPrice'>{discountedPrice} €</div>}
      <div className={discountedPrice !== undefined ? 'StrikethroughPrice' : ''}>{price} €</div>
    </div>
  </div>
);

const Review = inject("translationsStore")(observer(({connections, onCancel, onNext, translationsStore, discountAmount}) => (
  <div className="ReviewPayment">
    <h3>{translationsStore.translate('connectionRequests.checkout.review.title')}</h3>
    <div className="CheckoutContainer">
      {Object.values(
        connections.reduce((acc, curr) => {
          if (typeof acc[curr.rate_plan.id] === 'undefined') {
            acc[curr.rate_plan.id] = {count: 1, product: curr.zuora_product, rate_plan: curr.rate_plan};
          } else {
            acc[curr.rate_plan.id].count += 1;
          }

          return acc;
        }, {}))
        .map(product =>
          <ServiceListItem
            key={product.rate_plan.id}
            title={product.rate_plan.name}
            quantity={product.count}
            discountedPrice={discountAmount? `${product.count} x ${getDiscountedProductPrice(product.rate_plan, discountAmount) && getDiscountedProductPrice(product.rate_plan, discountAmount).toFixed(2)}` : undefined}
            price={`${product.count} x ${getProductPrice(product.rate_plan)}`}
            showCheckmark={true}
          />
        )
      }
      <ServiceListItem
        title={translationsStore.translate('connectionRequests.checkout.review.total')}
        subtitle={translationsStore.translate('connectionRequests.checkout.review.iva')}
        discountedPrice={discountAmount ?
          connections.reduce((acc, curr) =>
            acc + getDiscountedProductPrice(curr.rate_plan, discountAmount)
            , 0).toFixed(2) : undefined
        }
        price={
          connections.reduce((acc, curr) =>
            acc + getProductPrice(curr.rate_plan)
          , 0)
        }
      />
    </div>
    <div style={{display: 'flex', justifyContent: 'space-between'}}>
      <Button
        style={{width: 'auto'}}
        onClick={() => onCancel()}
        type="custom"
      >{translationsStore.translate('connectionRequests.checkout.review.cancel')}</Button>
      <Button
        style={{width: 'auto'}}
        onClick={() => onNext()}
        type="primary"
      >{translationsStore.translate('connectionRequests.checkout.review.confirm')}</Button>
    </div>
  </div>
)))

export default Review



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/CheckoutPopup/Review.js